var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "image-container", class: _vm.aspectRatio },
    [
      _c(
        "div",
        { staticClass: "image-inner" },
        [
          _vm._t("image-content-layer"),
          _vm._v(" "),
          _vm._t("image-attribution-overlay"),
          _vm._v(" "),
          _vm.hasImageTint
            ? _c("ImageTint", {
                attrs: {
                  "tint-strength": _vm.imageTintStrength,
                  "tint-style": "dark",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("AImage", {
            staticClass: "image",
            class: _vm.objectStyle,
            attrs: {
              img: _vm.fileStore,
              title: _vm.title,
              alt: _vm.alt,
              responsive: "",
              preset: "carousel-image",
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("image-attribution-footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }